import React, { createContext, useContext, useEffect, useState } from "react";

import { OrdersService } from "../../../services/logistic/orders";
import { callErrorToast } from "../../../utilities";

const ReturnDeliveredOrderContext = createContext();

const ordersService = new OrdersService();

const ReturnDeliveredOrdersProvider = ({ children, data, callback }) => {
  const [orders, setOrders] = useState(data);
  const [ordersError, setOrdersError] = useState(null);
  const [ordersLoader, setOrdersLoader] = useState(false);

  const returnDeliveredOrders = () => {
    setOrdersLoader(true);
    const returnDeliveredPromises = orders.map((elem) => {
      return ordersService.returnDelivered(elem.id);
    });
    Promise.all(returnDeliveredPromises)
      .then(() => {
        setOrdersLoader(false);
        if (callback) {
          callback(true);
        }
      })
      .catch((err) => {
        setOrdersLoader(false);
        setOrdersError(err);
      });
  };

  useEffect(() => {
    if (ordersError) {
      callErrorToast(ordersError);
    }
  }, [ordersError]);

  return (
    <ReturnDeliveredOrderContext.Provider
      value={{
        orders,
        ordersError,
        ordersLoader,
        returnDeliveredOrders,

        callback,
      }}
    >
      {children}
    </ReturnDeliveredOrderContext.Provider>
  );
};

const useReturnDeliveredOrderContext = () => {
  return useContext(ReturnDeliveredOrderContext);
};

export { ReturnDeliveredOrdersProvider, useReturnDeliveredOrderContext };
